import BaseService from "./BaseService";

class RewardService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/admin/rewards?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/admin/rewards`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/admin/rewards/${id}`);
  }

  static async update({ id, payload }) {
    return await BaseService.callAPI(`/admin/rewards/${id}`, "PUT", payload);
  }

  static async associations({ id }) {
    // Accept optional query params for server-side pagination & search
    // Expected params: pageNo, pageSize, sortColumn, sortBy, entityName
    const { pageNo, pageSize, sortColumn, sortBy, entityName } =
      arguments[0] || {};
    const params = BaseService.cleanQueryParams({
      pageNo,
      pageSize,
      sortColumn,
      sortBy,
      entityName,
    });
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `/admin/rewards/${id}/associations${queryParams ? `?${queryParams}` : ""}`
    );
  }

  static async delete({ id }) {
    return await BaseService.callAPI(`/admin/rewards/${id}`, "DELETE");
  }

  static async dropdown() {
    const response = await BaseService.callAPI(
      `/admin/rewards?IsActive=true&pageSize=1000`
    );
    return (
      response?.data?.list?.map((reward) => ({
        id: reward.id,
        name: reward.name,
        type: reward.type,
      })) || []
    );
  }
}

export const list = RewardService.list;
export const create = RewardService.create;
export const details = RewardService.details;
export const update = RewardService.update;
export const deleteReward = RewardService.delete;
export const dropdown = RewardService.dropdown;
export const associations = RewardService.associations;

export default RewardService;
